/**
 * Translates profile types into readable names.
 * @param  { string } profileType - The profile type to format.
 * @returns { string|undefined } - The formatted profile name or undefined if type is not recognized.
 */
export const formatProfileType = (profileType) => {
    switch (profileType) {
        case "nationalCoach": 
            return "Bundestrainer";
        case "coach": 
            return "Trainer";
        case "athlete": 
            return "Athlet";
        case "parent": 
            return "Elternteil";
        default: 
            return undefined;
    }
};